import script from "./rent_view_component.vue?vue&type=script&setup=true&lang=js"
export * from "./rent_view_component.vue?vue&type=script&setup=true&lang=js"

import "./rent_view_component.vue?vue&type=style&index=0&id=2a627f9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a627f9c"]])

export default __exports__